module.exports = __webpack_public_path__ + "static/media/conversion.e46da205.svg";